'use strict';

class validationService {
  constructor($log) {
    this.$log = $log;
  }

  isMicrosoft(email) {
    if (email && (email.match(/@hotmail.(\w+)/) || email.match(/@live.(\w+)/) || email.match(/@outlook.(\w+)/))) {
      const match = email.match(/^([\w\.]+)@([\w\.]+)$/);
      const domain = match && match.length >= 2 ? match[2] : 'hotmail/live/outlook';

      return {
        valid: false,
        message: `
          Vi opplever dessverre at e-post til <b>${domain}</b> av og til blir stoppet som s&oslash;ppelpost. Vi er i kontakt med v&aring;r e-postleverand&oslash;r og Microsoft for &aring; f&aring; l&oslash;st problemet.
          Vi anbefaler at du gj&oslash;r en av f&oslash;lgende alternativer:<br><br>
          <ul class="indent-list">
            <li>Kontakt kunden og sp&oslash;r om de har en alternativ e-postadresse.</li>
            <li>Kontakt kunden og be dem om &aring; legge til ikkesvar@sendregning.no som en sikker avsender, fremgangsm&aring;ten finnes <a href="http://answers.microsoft.com/nb-no/outlook_com/forum/oemail-osend/jeg-mottar-ikke-e-post-sendt-fra-vennerfamilie/968ec94e-d5fb-43da-9c51-889594f1778c" target="_blank">her</a>.</li>
            <li>Send regningen p&aring; papir.</li>
            <li>Du kan kostnadsfritt sende en sms om regningen. Regningen kan lastes ned til mobilen fra en lenke i sms-en.</li>
            <li>Send regningen til deg selv p&aring; e-post, last ned PDFen av regningen, og send regningen til kunden fra din egen e-post.</li>
          </ul>
          Vi beklager ulempene dette medf&oslash;rer og jobber for &aring; f&aring; rettet problemet.
        `
      };
    } else {
      return {
        valid: true,
        message: null
      };
    }
  }

  cleanupErrors() {
    $('span.error').remove();
    $('span.error').each(() => {
      $(this).remove();
    });
  }

  listError(name, err) {
    let el = document.getElementsByName(name)[0];

    if (el) {
      if (el.nextElementSibling) {
        el.nextElementSibling.remove();

        if (el.nextElementSibling && el.nextElementSibling.className === 'error') {
          el.nextElementSibling.remove();
        }
      } else {
        el.nextSibling.remove();

        if (el.nextSibling && el.nextSibling.className === 'error') {
          el.nextSibling.remove();
        }
      }
      el.classList.remove('ng-invalid');

      el.classList.add('ng-invalid');
      el.insertAdjacentHTML('afterend', '<span class="error">' + err + '</span>');
    } else {
      this.$log.debug('No element found with name: %s', name);
    }
  }

  // mark invalid field within form
  listErrors(arr) {
    if (arr && arr.length) {
      arr.forEach((e) => {
        if (document.getElementsByName(e.name)[0]) {
          document.getElementsByName(e.name)[0].classList.add('ng-invalid');
          document.getElementsByName(e.name)[0].insertAdjacentHTML('afterend', '<span class="error">' + e.endUserMessage + '</span>');
        } else {
          this.$log.debug('No element found with name: %s', e.name);
        }
      }, this);

      // scroll to first error
      if (document.querySelectorAll('.ng-invalid')[0]) {
        window.scrollTo(document.querySelectorAll('.ng-invalid')[0].offsetTop, document.querySelectorAll('.ng-invalid')[0].offsetLeft);
      }
    }
  }
}

validationService.$inject = ['$log'];

angular
  .module('SendRegning')
  .service('validationService', validationService);
